module.exports = __webpack_public_path__ + "img/laboratorio_3-4.7390851b.webp";